import type { MeasureEntity } from './entity/measureEntity';
import type { MeasureIRepository } from './entity/measureIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 測定アプリケーションサービス
 */
export class MeasureDomainService extends DomainServiceBase {
  private measureRepository!: MeasureIRepository;

  /**
   * Injection
   * @param measureRepository measureRepository
   */
  public inject(
    measureRepository: MeasureIRepository,
  ) {
    this.measureRepository = measureRepository;
  }

  /**
   * getMeasureList
   * @param token トークン
   * @returns 結果
   */
  async getMeasureList(token: string | null) {
    const result = await this.measureRepository.getList(token);
    const { nextToken } = result;
    const items = result.items.map((v: MeasureEntity) => v.toJson());
    return {
      /** 次のトークン */
      nextToken,
      /** アイテム一覧 */
      items,
    };
  }

  /**
   * createMeasure
   * @param entity 入力
   * @returns 結果
   */
  async createMeasure(
    entity: MeasureEntity,
  ) {
    const result = await this.measureRepository.create(entity);
    return result;
  }

  /**
   * updateMeasure
   * @param entity 入力
   * @returns 結果
   */
  async updateMeasure(
    entity: MeasureEntity,
  ) {
    const result = await this.measureRepository.update(entity);
    return result;
  }

  /**
   * deleteMeasure
   * @param entity 入力
   * @returns 結果
   */
  async deleteMeasure(
    entity: MeasureEntity,
  ) {
    const result = await this.measureRepository.delete(entity);
    return result;
  }
}
